import { createConfig, http } from "wagmi";
import { defineChain } from "viem";
import { injected } from "wagmi/connectors";

export const cronosMainnet = defineChain({
  id: 25,
  name: "Cronos Mainnet",
  nativeCurrency: { name: "CRO", symbol: "CRO", decimals: 18 },
  rpcUrls: { default: { http: ["https://evm.cronos.org/"] } },
  blockExplorers: {
    default: { name: "Cronoscan", url: "https://cronoscan.com" },
  },
});

export const wagmiConfig = createConfig({
  chains: [cronosMainnet],
  connectors: [injected()],
  transports: {
    [cronosMainnet.id]: http(),
  },
});

export const BURN_ADDRESS = "0x000000000000000000000000000000000000dEaD";
export const TREASURY_ADDRESS = "0x4F9cee25e92173Ae7abD3B923D4222f69c4d8F6f";
